import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { RootState } from "..";
import { ArtworkData, ArtworkMediaType, ArtworkUploadStatus } from "../../types/FloorPlan/Artwork.types";
import { callApi, callApiFile } from "../api";
import { checkArtworkStatus, getArtworksRequest, setArtworks, updateArtwork } from "../reducers/Artworks";
import { uploadArtwork } from "../reducers/FloorPlan/FloorPlan";
import { isSuccessResponse } from "../utils";
import missingImage from './../../assets/img/missing-image.png'

const validSculptureFileFormats = ['fbx'] as [string];
const validVideoFileFormats = ['mp4'] as [string];
const defaultPhoto = {
    fileName: missingImage,
    original: missingImage,
    large: missingImage,
    medium: missingImage,
    small: missingImage,
}

const offlineArtworkData = {
    "data": [
        {
            "uuid": "09a5db3f-d580-4d65-be6a-c60e880adb42",
            "created_at": "2023-03-16T14:48:06.000000Z",
            "updated_at": "2023-03-16T14:48:06.000000Z",
            "deleted_at": null,
            "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094",
            "title": {
                "en_EN": "Soft blue",
                "es_ES": "Black & Red"
            },
            "width": 110,
            "height": 150,
            "depth": 0,
            "unit": "cm",
            "year": "2020",
            "price": 1,
            "currency": "USD",
            "technique": {
                "en_EN": "Portrait",
                "es_ES": "tecnica artwork 1"
            },
            "has_variable_dimensions": 0,
            "is_unique": 0,
            "edition_total": 1,
            "edition_number": 1,
            "description": {
                "en_EN": "'Black is' is a project that focuses on the positives of being black and African. The project comprises of a mixture of African attires and accessories, to enlighten people outside of these communities of what being black or African is all about. Black symbolises Love, Beauty, Power, Strength, Endurance, Authority, Excellence, Vulnerability, Uniqueness, Resilience and so much more which can be portrayed in beautiful ways but are rarely showcased.",
                "es_ES": "'Black is' is a project that focuses on the positives of being black and African. The project comprises of a mixture of African attires and accessories, to enlighten people outside of these communities of what being black or African is all about. Black symbolises Love, Beauty, Power, Strength, Endurance, Authority, Excellence, Vulnerability, Uniqueness, Resilience and so much more which can be portrayed in beautiful ways but are rarely showcased.",
            },
            "media_type": "IMAGE",
            "type": "PAINTING",
            "is_sold": 0,
            "has_info_dimensions": 0,
            "info_width": 0,
            "info_height": 0,
            "info_depth": 0,
            "artwork_in_exhibition": {
                "id_exhibition": 1,
                "id_artwork": 1,
                "x": null,
                "y": null,
                "side": null,
                "id_wall": null,
                "has_frame": 0,
                "frame_width": "0.00",
                "frame_color": "#121212",
                "passepartout_width": "0.00",
                "passepartout_color": "#ffffff",
                "width_in_exhibition": "90.00",
                "height_in_exhibition": "110.00",
                "order": null,
                "frame_depth": "0.00",
                "edge_color": "#bcbcbc",
                "frame_texture_id": null,
                "frame_material": "0001"
            },
            "photo": {
                "uuid": "812faa30-b7f0-4f97-8d2e-4c297d3e54e0",
                "file_name": null,
                "original": "https://d22j8f47u6lqy6.cloudfront.net/demo/BlackBlue.jpg",
                "large": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/BlackBlue.jpg&w=1200",
                "medium": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/BlackBlue.jpg&w=800",
                "small": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/BlackBlue.jpg&w=400"
            },
            "photos": [],
            "artist": {
                "firstname": "Oladimeji",
                "lastname": "Odunsi",
                "web": "https://www.sipes.com/dolorem-aliquam-quas-amet-nulla-molestias-aut-aut",
                "uuid": "12779a6f-854d-470d-8caf-2215040a01e3",
                "created_at": "2023-03-16T14:48:06.000000Z",
                "updated_at": "2023-03-16T14:48:06.000000Z",
                "deleted_at": null,
                "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094"
            },
            "video": null,
            "sculpture": null,
            "main_2d_photo": null
        },
        {
            "uuid": "f040c673-e1ff-46b4-bf01-e18c832eb763",
            "created_at": "2023-03-16T14:48:06.000000Z",
            "updated_at": "2023-09-26T12:42:39.000000Z",
            "deleted_at": null,
            "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094",
            "title": {
                "en_EN": "Greco-Roman Renaissance",
                "es_ES": "titulo artwork 2"
            },
            "width": 100,
            "height": 220,
            "depth": 80,
            "unit": "cm",
            "year": "2019",
            "price": 56.97,
            "currency": "EUR",
            "technique": {
                "en_EN": "digital art",
                "es_ES": "tecnica artwork 2"
            },
            "has_variable_dimensions": 0,
            "is_unique": 0,
            "edition_total": 1,
            "edition_number": 1,
            "description": {
                "en_EN": "Greco-Roman Renaissance sculpture",
                "es_ES": "descripcion artwork 2"
            },
            "media_type": "SCULPTURE",
            "type": "SCULPTURE",
            "is_sold": 0,
            "has_info_dimensions": 0,
            "info_width": 0,
            "info_height": 0,
            "info_depth": 0,
            "artwork_in_exhibition": {
                "id_exhibition": 1,
                "id_artwork": 2,
                "x": null,
                "y": null,
                "side": null,
                "id_wall": null,
                "has_frame": 0,
                "frame_width": "0.00",
                "frame_color": null,
                "passepartout_width": "0.00",
                "passepartout_color": null,
                "width_in_exhibition": "0.00",
                "height_in_exhibition": "0.00",
                "order": null,
                "frame_depth": "0.00",
                "edge_color": null,
                "frame_texture_id": null,
                "frame_material": null
            },
            "photo": {
                "uuid": "720b18ce-80f9-4a58-9611-38c30287c41b",
                "file_name": null,
                "original": "https://d22j8f47u6lqy6.cloudfront.net/demo/Sculpture.png",
                "large": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/Sculpture.png&w=1200",
                "medium": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/Sculpture.png&w=800",
                "small": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/Sculpture.png&w=400"
            },
            "photos": [],
            "artist": {
                "firstname": "Marti",
                "lastname": "Mayoral",
                "web": "https://www.martimayo.com/",
                "uuid": "12779a6f-854d-470d-8caf-2215040a01e3",
                "created_at": "2023-03-16T14:48:06.000000Z",
                "updated_at": "2023-03-16T14:48:06.000000Z",
                "deleted_at": null,
                "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094"
            },
            "video": null,
            "sculpture": {
                "id_account": 1,
                "uuid": "647d8aab-00e2-4d7f-b58b-795352727dab",
                "file_url": "https://d22j8f47u6lqy6.cloudfront.net/demo/Greco-Roman_Renaissance_grey.fbx",
                "created_at": "2023-09-26T12:42:38.000000Z",
                "updated_at": "2023-09-26T12:42:41.000000Z",
                "file_name": "Greco-Roman_Renaissance_grey.fbx",
                "upload_status": "uploaded",
                "uploaded_at": "2023-09-26 12:42:41"
            },
            "main_2d_photo": null
        },
        {
            "uuid": "85877346-35f3-4458-bbd3-fc9ae110bf13",
            "created_at": "2023-03-16T14:48:06.000000Z",
            "updated_at": "2023-03-23T17:32:49.000000Z",
            "deleted_at": null,
            "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094",
            "title": {
                "en_EN": "Cyan",
                "es_ES": "titulo artwork 3"
            },
            "width": 84,
            "height": 104,
            "depth": 0,
            "unit": "cm",
            "year": "2016",
            "price": 2500,
            "currency": "EUR",
            "technique": {
                "en_EN": "",
                "es_ES": "tecnica artwork 3"
            },
            "has_variable_dimensions": 0,
            "is_unique": 0,
            "edition_total": 1,
            "edition_number": 1,
            "description": {
                "en_EN": "OO1",
                "es_ES": "descripcion artwork 3"
            },
            "media_type": "IMAGE",
            "type": "PAINTING",
            "is_sold": 0,
            "has_info_dimensions": 0,
            "info_width": 0,
            "info_height": 0,
            "info_depth": 0,
            "artwork_in_exhibition": {
                "id_exhibition": 1,
                "id_artwork": 3,
                "x": "350.00",
                "y": "110.40",
                "side": "right",
                "id_wall": 320,
                "has_frame": 1,
                "frame_width": "5.00",
                "frame_color": "#ffffff",
                "passepartout_width": "0.00",
                "passepartout_color": "#ffffff",
                "width_in_exhibition": "120.00",
                "height_in_exhibition": "150.00",
                "order": null,
                "frame_depth": "0.00",
                "edge_color": "#bcbcbc",
                "frame_texture_id": null,
                "frame_material": "0001"
            },
            "photo": {
                "uuid": "e9539737-7f4b-4c2d-ace3-e3aba22d3cc9",
                "file_name": null,
                "original": "https://d22j8f47u6lqy6.cloudfront.net/demo/Oladimeji_Odunsi.jpg",
                "large": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/Oladimeji_Odunsi.jpg&w=1200",
                "medium": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/Oladimeji_Odunsi.jpg&w=800",
                "small": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/Oladimeji_Odunsi.jpg&w=400"
            },
            "photos": [],
            "artist": {
                "firstname": "Oladimeji",
                "lastname": "Odunsi",
                "web": "https://www.sipes.com/dolorem-aliquam-quas-amet-nulla-molestias-aut-aut",
                "uuid": "12779a6f-854d-470d-8caf-2215040a01e3",
                "created_at": "2023-03-16T14:48:06.000000Z",
                "updated_at": "2023-03-16T14:48:06.000000Z",
                "deleted_at": null,
                "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094"
            },
            "video": {
                "id": 6,
                "id_account": 1,
                "uuid": "774dabda-f85f-4091-b59d-2bc436521b5a",
                "url": "",
                "duration": "00:00:00",
                "title": null,
                "thumbnail_url": null,
                "created_at": "2023-09-22T11:17:59.000000Z",
                "updated_at": "2023-09-22T11:18:03.000000Z",
                "thumbnail_url_low": null,
                "thumbnail_url_high": null,
                "mute": 0,
                "auto_start": 1,
                "file_url": "https://exb-images.s3.eu-west-1.amazonaws.com/99bQTbFbV6gforEo3V0Jrta2l.mp4",
                "upload_status": "uploaded",
                "uploaded_at": "2023-09-22 11:18:03",
                "file_name": "fluid_2.mp4"
            },
            "sculpture": null,
            "main_2d_photo": null
        },
        {
            "uuid": "6584f49f-251b-4904-8caa-29ddce35b344",
            "created_at": "2023-03-16T14:48:06.000000Z",
            "updated_at": "2023-09-22T11:18:00.000000Z",
            "deleted_at": null,
            "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094",
            "title": {
                "en_EN": "Fluid video",
                "es_ES": "titulo artwork 4"
            },
            "width": 160,
            "height": 90,
            "depth": 5,
            "unit": "cm",
            "year": "2004",
            "price": 13.16,
            "currency": "EUR",
            "technique": {
                "en_EN": "fluid simulation",
                "es_ES": "tecnica artwork 4"
            },
            "has_variable_dimensions": 0,
            "is_unique": 0,
            "edition_total": 1,
            "edition_number": 1,
            "description": {
                "en_EN": "This is a sample video to showcase a custom uploaded video",
                "es_ES": "descripcion artwork 4"
            },
            "media_type": "VIDEO",
            "type": "PAINTING",
            "is_sold": 0,
            "has_info_dimensions": 0,
            "info_width": 0,
            "info_height": 0,
            "info_depth": 0,
            "artwork_in_exhibition": {
                "id_exhibition": 1,
                "id_artwork": 4,
                "x": "95.00",
                "y": "145.40",
                "side": "right",
                "id_wall": 319,
                "has_frame": 0,
                "frame_width": "0.00",
                "frame_color": "#121212",
                "passepartout_width": "0.00",
                "passepartout_color": "#ffffff",
                "width_in_exhibition": "160.00",
                "height_in_exhibition": "90.00",
                "order": null,
                "frame_depth": "5.00",
                "edge_color": "#bcbcbc",
                "frame_texture_id": null,
                "frame_material": "0001"
            },
            "photo": {
                "uuid": "e0cf612f-4a14-48e6-827a-a0f111efe54e",
                "file_name": null,
                "original": "https://d22j8f47u6lqy6.cloudfront.net/demo/video.jpg",
                "large": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/video.jpg&w=1200",
                "medium": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/video.jpg&w=800",
                "small": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/video.jpg&w=400"
            },
            "photos": [],
            "artist": {
                "firstname": "Marti",
                "lastname": "Mayoral",
                "web": "https://martimayo.com/",
                "uuid": "12779a6f-854d-470d-8caf-2215040a01e3",
                "created_at": "2023-03-16T14:48:06.000000Z",
                "updated_at": "2023-03-16T14:48:06.000000Z",
                "deleted_at": null,
                "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094"
            },
            "video": {
                "id": 4,
                "id_account": 1,
                "uuid": "411747e7-0508-4574-906c-ba6afb380d18",
                "url": "",
                "duration": "00:00:00",
                "title": null,
                "thumbnail_url": null,
                "created_at": "2023-03-23T17:32:48.000000Z",
                "updated_at": "2023-03-23T17:32:55.000000Z",
                "thumbnail_url_low": null,
                "thumbnail_url_high": null,
                "mute": 0,
                "auto_start": 1,
                "file_url": "https://exb-images.s3.eu-west-1.amazonaws.com/IgXPsIarZp3hDDgKjp1kJFo0u.mp4",
                "upload_status": "uploaded",
                "uploaded_at": "2023-03-23 17:32:55",
                "file_name": "CubeReem 30 sec test @ 4K - Copy.mp4"
            },
            "sculpture": null,
            "main_2d_photo": null
        },
        {
            "uuid": "36ef80ca-5534-488b-a200-a19e04cd906e",
            "created_at": "2023-03-16T14:48:06.000000Z",
            "updated_at": "2023-03-16T14:48:06.000000Z",
            "deleted_at": null,
            "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094",
            "title": {
                "en_EN": "Black & Red"
            },
            "width": 100,
            "height": 150,
            "depth": 5,
            "unit": "cm",
            "year": "1991",
            "price": 30.72,
            "currency": "EUR",
            "technique": {
                "en_EN": ""
            },
            "has_variable_dimensions": 0,
            "is_unique": 0,
            "edition_total": 1,
            "edition_number": 1,
            "description": {
                "en_EN": "\"Black is” is a project that focuses on the positives of being black and African. The project comprises of a mixture of African attires and accessories, to enlighten people outside of these communities of what being black or African is all about. Black symbolises Love, Beauty, Power, Strength, Endurance, Authority, Excellence, Vulnerability, Uniqueness, Resilience and so much more which can be portrayed in beautiful ways but are rarely showcased."
            },
            "media_type": "IMAGE",
            "type": "PAINTING",
            "is_sold": 0,
            "has_info_dimensions": 0,
            "info_width": 0,
            "info_height": 0,
            "info_depth": 0,
            "artwork_in_exhibition": {
                "id_exhibition": 1,
                "id_artwork": 5,
                "x": "140.00",
                "y": "115.40",
                "side": "right",
                "id_wall": 320,
                "has_frame": 0,
                "frame_width": "0.00",
                "frame_color": "#121212",
                "passepartout_width": "0.00",
                "passepartout_color": "#ffffff",
                "width_in_exhibition": "100.00",
                "height_in_exhibition": "150.00",
                "order": null,
                "frame_depth": "10.00",
                "edge_color": "#bcbcbc",
                "frame_texture_id": null,
                "frame_material": "0001"
            },
            "photo": {
                "uuid": "6d2dafec-25ec-41b4-9f62-db2cd0830d81",
                "file_name": null,
                "original": "https://d22j8f47u6lqy6.cloudfront.net/demo/lucas-gouvea-aoEwuEH7YAs-unsplash.jpg",
                "large": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/lucas-gouvea-aoEwuEH7YAs-unsplash.jpg&w=1200",
                "medium": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/lucas-gouvea-aoEwuEH7YAs-unsplash.jpg&w=800",
                "small": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/lucas-gouvea-aoEwuEH7YAs-unsplash.jpg&w=400"
            },
            "photos": [],
            "artist": {
                "firstname": "Oladimeji",
                "lastname": "Odunsi",
                "web": "https://www.sipes.com/dolorem-aliquam-quas-amet-nulla-molestias-aut-aut",
                "uuid": "12779a6f-854d-470d-8caf-2215040a01e3",
                "created_at": "2023-03-16T14:48:06.000000Z",
                "updated_at": "2023-03-16T14:48:06.000000Z",
                "deleted_at": null,
                "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094"
            },
            "video": null,
            "sculpture": null,
            "main_2d_photo": null
        },
        {
            "uuid": "7378d2fc-5d10-4b0c-8947-4c490adf9977",
            "created_at": "2023-03-16T14:48:06.000000Z",
            "updated_at": "2023-03-16T14:48:06.000000Z",
            "deleted_at": null,
            "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094",
            "title": {
                "en_EN": "Cyan"
            },
            "width": 100,
            "height": 150,
            "depth": 10,
            "unit": "cm",
            "year": "2018",
            "price": 59.75,
            "currency": "EUR",
            "technique": [],
            "has_variable_dimensions": 0,
            "is_unique": 0,
            "edition_total": 1,
            "edition_number": 1,
            "description": [],
            "media_type": "IMAGE",
            "type": "PAINTING",
            "is_sold": 0,
            "has_info_dimensions": 0,
            "info_width": 0,
            "info_height": 0,
            "info_depth": 0,
            "artwork_in_exhibition": {
                "id_exhibition": 1,
                "id_artwork": 6,
                "x": null,
                "y": null,
                "side": null,
                "id_wall": null,
                "has_frame": 0,
                "frame_width": "0.00",
                "frame_color": "#121212",
                "passepartout_width": "0.00",
                "passepartout_color": "#ffffff",
                "width_in_exhibition": "100.00",
                "height_in_exhibition": "150.00",
                "order": null,
                "frame_depth": "46.41",
                "edge_color": "#bcbcbc",
                "frame_texture_id": null,
                "frame_material": "0001"
            },
            "photo": {
                "uuid": "50a6983a-0430-4c14-a846-562f52f5ec12",
                "file_name": null,
                "original": "https://d22j8f47u6lqy6.cloudfront.net/demo/redBlue.jpg",
                "large": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/redBlue.jpg&w=1200",
                "medium": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/redBlue.jpg&w=800",
                "small": "https://api.exhibify.net/image_process/resize.php?src=https://d22j8f47u6lqy6.cloudfront.net/demo/redBlue.jpg&w=400"
            },
            "photos": [],
            "artist": {
                "firstname": "Oladimeji",
                "lastname": "Odunsi",
                "web": "https://www.sipes.com/dolorem-aliquam-quas-amet-nulla-molestias-aut-aut",
                "uuid": "12779a6f-854d-470d-8caf-2215040a01e3",
                "created_at": "2023-03-16T14:48:06.000000Z",
                "updated_at": "2023-03-16T14:48:06.000000Z",
                "deleted_at": null,
                "account": "c5a822bb-6acf-48d9-bbb8-bbd4671a9094"
            },
            "video": null,
            "sculpture": null,
            "main_2d_photo": null
        }
    ]
}

export function* doGetExhibitionArworks({ payload: uuid }: PayloadAction<string>) {
    // console.log("doGetExhibitionArworks", uuid)
    try {
        // const artworksResponse: AxiosResponse = yield call(callApi, 'GET', `/exhibitions/${uuid}/artworks`)
        // if (!isSuccessResponse(artworksResponse, true)) {
        //     console.error(artworksResponse)
        //     throw new Error('Unable to get exhibition.')
        // }

        // console.log("artworksResponse", artworksResponse.data.data)
        // const artworksRaw = artworksResponse.data.data
        const artworksRaw = offlineArtworkData.data
        // console.log("Artworksdata", artworksRaw)

        const artworks: { [id: string]: ArtworkData } = {}

        for (let i = 0; i < artworksRaw.length; i++) {
            const item = artworksRaw[i]

            var media = null
            if (item.media_type === "SCULPTURE" && item.sculpture)
                media = {
                    name: item.sculpture.file_name,
                    uuid: item.sculpture.uuid,
                    status: item.sculpture.upload_status
                }

            if (item.media_type === "VIDEO" && item.video)
                media = {
                    name: item.video.file_name,
                    uuid: item.video.uuid,
                    status: item.video.upload_status
                }

            artworks[item.uuid] = {
                uuid: item.uuid,

                title: item.title,
                width: item.width,
                height: item.height,
                depth: item.depth,
                unit: item.unit,
                year: item.year,
                price: item.price,
                currency: item.currency,
                mediaType: item.media_type,
                artist: {
                    firstName: item.artist.firstname,
                    lastName: item.artist.lastname,
                    web: item.artist.web,
                },
                description: item.description,
                photo: item.photo ? {
                    fileName: item.photo.file_name,
                    original: item.photo.original,
                    large: item.photo.large,
                    medium: item.photo.medium,
                    small: item.photo.small,
                } : defaultPhoto,
                media
            } as any
        }

        // console.log("set artworks", artworks)
        yield put(setArtworks(artworks))

    } catch (error) {
        if (error instanceof Error) {
            console.error(error.message)
        } else {
            // console.log('Unexpected error', error);
        }/* 
        yield put(openNotification('An error occurred when getting exhibition map.', 'error'));
        yield put(errorAction(type, error)); */
    } finally {
        // yield put(successAction(type));
    }
}


export function* watchGetArtworks() {
    yield takeLatest(getArtworksRequest, doGetExhibitionArworks);
}

function* setUploadState(artworkUuid: string, artworkData: ArtworkData, status: ArtworkUploadStatus, error?: string) {
    const artworkDataCopy = { ...artworkData }
    if (artworkDataCopy.media) {
        artworkDataCopy.media = {
            ...artworkDataCopy.media,
            status,
            error
        }
        yield put(updateArtwork({ id: artworkUuid, data: artworkDataCopy }))
    }
}

function* doUploadArtwork({ payload }: PayloadAction<{ artworkUuid: string, file: File }>) {
    const { artworkUuid, file } = payload
    if (!file || file == null)
        return


    if (!artworkUuid || artworkUuid === null || artworkUuid === "") {
        console.error("no artwork_uuid given")
        return
    }

    const artworkData: ArtworkData = yield select((state: RootState) => state.artworks.artworks[artworkUuid])
    const type = artworkData?.mediaType
    if (type === "IMAGE" || !!!type) return

    yield setUploadState(artworkUuid, artworkData, "upload_pending")

    try {
        // console.log("doUploadSculpture", artworkUuid)

        const { size, name } = file
        if (size > 70 * 1024 * 1024) {
            console.error('Artwork size must be under 70Mb.')
            yield setUploadState(artworkUuid, artworkData, "upload_failed", "Artwork size must be under 70Mb.")
            return
        }


        const split = name.split('.');
        const fileFormat = split[split.length - 1].toLowerCase();
        const validFormats = type === "SCULPTURE" ? validSculptureFileFormats : validVideoFileFormats
        if (!validFormats.includes(fileFormat)) {
            const formats = validFormats.join(', .');
            const errorMessage = 'Invalid file.\n Valid artwork formats are: .' + formats
            console.error(errorMessage)

            yield setUploadState(artworkUuid, artworkData, "upload_failed", errorMessage)
            return
        }

        var endpoint = type === "SCULPTURE" ? "/sculptures" : "/videos"
        const uploadSculptureRes: AxiosResponse = yield call(callApiFile, 'POST', endpoint, { mediaType: type, file })

        if (!isSuccessResponse(uploadSculptureRes, true)) {
            console.error(uploadSculptureRes)
            yield setUploadState(artworkUuid, artworkData, "upload_failed", "Unable to upload artwork")
            return
        }

        const data: {
            file_name: string,
            uuid: string,
            file_url: string,
            id_accound: number,
            upload_status: ArtworkUploadStatus,
        } | undefined = uploadSculptureRes.data?.data
        if (!data) {
            yield setUploadState(artworkUuid, artworkData, "upload_failed", "Unable to upload artwork")
            return
        }
        const mediaUuid = data.uuid
        if (!mediaUuid) {
            yield setUploadState(artworkUuid, artworkData, "upload_failed", "Unable to upload artwork")
            return
        }

        endpoint = type === "SCULPTURE" ? "/sculpture" : "/video"
        const res: AxiosResponse = yield call(callApi, 'PUT', "/artworks/" + artworkUuid + endpoint, {
            uuid: mediaUuid
        })

        if (!isSuccessResponse(res, true)) {
            console.error(res)
            throw new Error('Unable to assign sculpture')
        }


        const artworkDataCopy = { ...artworkData }
        artworkDataCopy.media = {
            name: data.file_name,
            uuid: data.uuid,
            status: data.upload_status
        }

        yield put(updateArtwork({ id: artworkUuid, data: artworkDataCopy }))
        yield put(checkArtworkStatus({ artworkUuid, mediaUuid, type }))

    } catch (error: any) {
        console.error(error)
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            return error.response;
        }
        return error;
    }
}

export function* watchUploadSculpture() {
    yield takeLatest(uploadArtwork, doUploadArtwork)
}

function* doCheckArtworkStatus({ payload }: PayloadAction<{ type: ArtworkMediaType, artworkUuid: string, mediaUuid: string }>) {
    const { type, artworkUuid, mediaUuid } = payload
    if (type === "IMAGE")
        return
    // console.log("CheckArtworkStatus")

    const artworkData: ArtworkData = yield select((state: RootState) => state.artworks.artworks[artworkUuid])
    const artworkDataCopy = { ...artworkData }
    if (!artworkDataCopy || !artworkDataCopy.media) {
        console.error("could not find artwork", artworkUuid)
        return
    }
    const currentUploadStatus = artworkDataCopy.media.status

    const uri = type === "SCULPTURE" ? `/sculptures/${mediaUuid}` : `/videos/${mediaUuid}`
    const artworksResponse: AxiosResponse = yield call(callApi, 'GET', uri)

    if (currentUploadStatus === "upload_failed" || currentUploadStatus === "uploaded") return

    if (!isSuccessResponse(artworksResponse)) {
        console.error(artworksResponse)
        throw new Error('Unable to get exhibition.')
    }
    // console.log("mediaResponse", artworksResponse.data.data)

    const response: {
        file_name: string,
        file_url: string,
        upload_status: ArtworkUploadStatus
        uuid: string
    } = artworksResponse.data.data

    // update artwork
    if (currentUploadStatus !== response.upload_status) {
        artworkDataCopy.media = {
            name: response.file_name,
            uuid: response.uuid,
            status: response.upload_status
        }
        yield put(updateArtwork({ id: artworkUuid, data: artworkDataCopy }))
    }


    if (response.upload_status === "upload_pending" || response.upload_status === "uploading") {
        yield delay(500)
        yield put(checkArtworkStatus({ artworkUuid, mediaUuid, type }))
    }



    /* 
        const artworkData: ArtworkData = yield select((state: RootState) => state.artworks.artworks[artworkUuid])
        const artworkDataCopy = { ...artworkData }
    
        if (currentUploadStatus === "upload_failed") {
            yield put(updateArtwork({ id: artworkUuid, data: artworkDataCopy }))
            if (artworkDataCopy.sculpture)
                artworkDataCopy.sculpture.status = ""
        } */
}

export function* watchCheckArtworkStatus() {
    yield takeLatest(checkArtworkStatus, doCheckArtworkStatus)
}